// extracted by mini-css-extract-plugin
export default {"text":"HintOpenCompromisingFolder_text__NTVyV"};